import React from "react";

const COLORS = ['#FFCE00', '#E4003C', '#0B72C9', '#2E9B3F', '#96298E', '#F47B20'];

// The six animated brand colour bars.
const Bars = ({w = 26, h = 5, gap = 6}) => (
    <div className="pb-bars" style={{gap: gap + 'px'}}>
        {COLORS.map((color, i) => (
            <span key={color} style={{
                width: w + 'px', height: h + 'px', background: color,
                animationDelay: (i * 0.13).toFixed(2) + 's'
            }}/>
        ))}
    </div>
);

export default Bars;
